import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  FormHelperText,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ticket from './icons/ic_validacion.svg';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  input: {
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderRadius: 5,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f1f1f1',
    },
    width: '100%',
  },
  helperText: {
    textAlign: 'right',
  },
  errorText: {
    textAlign: 'right',
    color: 'red',
  },
  image: {
    height: 20,
    width: 20,
  },
}));

const AppInput = ({ ...props }) => {
  const {
    name,
    error,
    value,
    label,
    helperText,
    errorMessage,
    inputAdornment,
    required,
    onChange,
    onBlur,
    onClick,
    type,
    autoComplete,
    disabled,
    success,
    multiline,
    showTogglePassword,
  } = props;

  const handleChange = (event) => {
    onChange(event);
  };
  const handleBlur = (event) => {
    onBlur && onBlur(event);
  };
  const handleClick = (event) => {
    onClick(event);
  };

  const [values, setValues] = useState({
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <TextField
        data-cy={`input${name}`}
        disabled={disabled}
        name={name}
        error={error}
        type={values.showPassword ? 'text' : type}
        value={value}
        label={label}
        autoComplete={autoComplete}
        required={required}
        onChange={handleChange}
        onBlur={handleBlur}
        onClick={handleClick}
        size="small"
        variant="outlined"
        multiline={multiline}
        rows={4}
        InputProps={{
          startAdornment: inputAdornment && (
            <InputAdornment position="start">{inputAdornment}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {type === 'password' && showTogglePassword && (
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              )}
              {success && type !== 'password' && (
                <img
                  className={classes.image}
                  src={ticket}
                  data-cy={`img${name}`}
                />
              )}
            </InputAdornment>
          ),
        }}
        className={classes.input}
      />
      {!error && helperText && (
        <FormHelperText className={classes.helperText}>
          {helperText}
        </FormHelperText>
      )}
      {error && (
        <FormHelperText className={classes.errorText}>
          {errorMessage}
        </FormHelperText>
      )}
    </React.Fragment>
  );
};

AppInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  inputAdornment: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.string,
  autoComplete: PropTypes.bool,
  disabled: PropTypes.bool,
  success: PropTypes.bool,
  multiline: PropTypes.bool,
  showTogglePassword: PropTypes.bool,
};

export default AppInput;
